import React from 'react';

import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import { Route, Redirect, withRouter } from 'react-router-dom';



import SplitContainer from '@zippytech/react-toolkit/SplitContainer'
import '@zippytech/react-toolkit/SplitContainer/index.css'

import LoadingComponent from '../../common/LoadingComponent';
import MyPracticeTreeView from "./BrowserPane/MyPracticeTreeMenu";
import IndexResourcePane from "./ResourcesPane/Index";
import LibraryView from "./DesignerPane/Practice/ViewLibrary";
import CreatePack from "./DesignerPane/Practice/CreatePack";
import { HelpComponent } from "../../common/HelpComponent";
import PracticeFlowAndCommunity from './DesignerPane/Practice/PracticeFlowandCommunity'
import PracticeFlowActivity from './DesignerPane/Practice/PracticeFlowActivityView'
import CommunityActivity from './DesignerPane/Practice/CommunityActivityView'
import SummaryView from './DesignerPane/Practice/SummaryView'
import SwimLineView from './DesignerPane/Practice/SwimLineView'
import PublishPack from './DesignerPane/Practice/PublishPack'
import AdditionalInformation from './DesignerPane/Practice/AdditionalInformation'
import ReactResizeDetector from 'react-resize-detector';
import './LifecycleCommon.css';


class LifecycleDesigner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            splitAt: "60%",
            browserPaneSplit: "25%",
            collapsedResourcePaneIndex: null
        }
        this.parentRef = React.createRef();
        // this.onResizeDesigner = this.onResizeDesigner.bind(this)
        this.onResizeResource = this.onResizeResource.bind(this)
    }
    componentWillMount() {
        dispatch.categories.getAllCategories({ organizationId: this.props.match.params.workspaceId })
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.app.setCurrentContext("designer");
        // dispatch.lifeCycle.getCategoryAsync({ "accountId": this.props.selectedAccount._id });
        dispatch.lifeCycle.setArrangementPaneFlag(false);
        dispatch.lifeCycle.displaySecondMenu(null);
        dispatch.lifeCycle.setIsDragableFlag(null);
        // dispatch.lifeCycle.setSelectedPracticeLibrary({});
        dispatch.integrations.getIntegrationEntities(this.props.selectedOrganisation);
        // dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, scope: "Public" });

    }
    componentDidMount = async () => {
        await dispatch.app.setRouteParams(this.props.match.params);
        dispatch.lifeCycle.isSortingFlag(
            { key: "createdAt", order: 1, text: "CreatedAt" }
        );
        document.addEventListener("keydown", this.keyPress, false);
    }

    onResizeResource(width, height) {

        let windowHeight = window.innerHeight;
        let designerDimension = {
            width: width,
            windowHeight: windowHeight,
            height: height
        }
        dispatch.initiatives.setDesignerDimension(designerDimension);


        if (this.props.setUniqueId) {
            const initiativeCardElement = document.getElementById(this.props.setUniqueId);
            if (initiativeCardElement) {
                setTimeout(() => {
                    initiativeCardElement.scrollIntoView({ block: 'center', inline: "nearest" });
                }, 100);
            }
        }

    }

    keyPress = async (e) => {

        let selectedPlaybookObj = Object.entries(this.props.selectedPracticeLibrary).length !== 0 && this.props.selectedPracticeLibrary.constructor === Object
        let selectedActivityObj = Object.entries(this.props.selectedPracticeFlowActivity).length !== 0 && this.props.selectedPracticeFlowActivity.constructor === Object
        let selectedCommunityObj = Object.entries(this.props.selectedPracticeFlowCommunity).length !== 0 && this.props.selectedPracticeFlowCommunity.constructor === Object

        if (e.keyCode === 27) {
            dispatch.app.setCollapsedResourcePaneIndexTemp(null);
            dispatch.lifeCycle.modalOpen(false);
            await dispatch.lifeCycle.showResourecePane(null);
            dispatch.lifeCycle.splitAt("60%")
            if (selectedPlaybookObj && !selectedActivityObj && !selectedCommunityObj) {
                dispatch.lifeCycle.showResourecePane(null);
                dispatch.lifeCycle.updateLibraryCardIndex(null);
                dispatch.lifeCycle.modalOpen(false);
                dispatch.lifeCycle.setArrangementPaneFlag(false);


            } else if (selectedActivityObj) {
                dispatch.lifeCycle.showResourecePane(null);
                dispatch.initiatives.setIdToCenterPosition(null);
                dispatch.createPack.activityUniqueIdSet(null);
                dispatch.createPack.setSelectedActivityData({});

            } else if (selectedCommunityObj) {
                dispatch.lifeCycle.showResourecePane(null);
                dispatch.initiatives.setIdToCenterPosition(null);
                dispatch.createPack.setRACIObjectOnCommunity({});
            }
        }
    }


    render() {

        let designerContainer;
        designerContainer = <SplitContainer
            orientation="horizontal"
            splitAt={this.props.showResourecePaneFlag && this.props.splitAtSize ? this.props.splitAtSize : "100%"}
            locked={this.props.showResourecePaneFlag === null}
            minSize={["0%", "0%"]}
            maxSize={[null, '81%']}
            collapsible={[true, true]}
            fillSides={[true, true]}
            resizeProxy={true}
            collapsedIndex={this.props.collapsedResourcePaneIndexTemp === 1 || this.props.collapsedResourcePaneIndexTemp === 0 ? this.state.collapsedResourcePaneIndex : this.props.collapsedResourcePaneIndexTemp}
            onResize={(splitAt) => {
                if (Number(splitAt.replace("%", "")) < 30) {
                    this.setState({ collapsedResourcePaneIndex: 0 })
                    dispatch.app.setCollapsedResourcePaneIndexTemp(0)
                } else if (Number(splitAt.replace("%", "")) > 80) {
                    this.setState({ collapsedResourcePaneIndex: 1 })
                    dispatch.app.setCollapsedResourcePaneIndexTemp(1)
                } else {
                    this.setState({ collapsedResourcePaneIndex: null })
                    dispatch.lifeCycle.splitAt(splitAt)
                    dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                }
            }}
            onExpand={() => {
                this.setState({ collapsedResourcePaneIndex: null })
                dispatch.app.setCollapsedResourcePaneIndexTemp(null)
                dispatch.lifeCycle.splitAt("60%")
            }}
            onCollapse={(index) => {
                this.setState({ collapsedResourcePaneIndex: index })
                dispatch.app.setCollapsedResourcePaneIndexTemp(index)
            }}
            onKeyDown={this.keyPress}
        >
            <SplitContainer.Side className="Split-DesignerPane" >

                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb" render={() => (<LibraryView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/status/:status" render={() => (<LibraryView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/status/:status/:baseCategory" render={() => (<LibraryView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/status/:status/:baseCategory/:category" render={() => (<LibraryView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/status/:status/:baseCategory/:category/:subCategory" render={() => (<LibraryView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/page/:status" render={() => (<CreatePack  {...this.props} space='Create Pack' />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/:playbookId/configure" render={() => (<PracticeFlowAndCommunity  {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/:playbookId/sequence" render={() => (<PracticeFlowActivity {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/:playbookId/assign" render={() => (<CommunityActivity {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/:playbookId/summary" render={() => (<SummaryView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/swimlineStructure" render={() => (<SwimLineView {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/:playbookId/additionalInformation" render={() => (<AdditionalInformation  {...this.props} />)} />
                <Route exact path="/app/:accountId/_ws/:workspaceId/_pb/steps/:playbookId/publish" render={() => (<PublishPack  {...this.props} />)} />


            </SplitContainer.Side>
            <SplitContainer.Side className="Split-ResourcePane"   >
                <ReactResizeDetector handleWidth handleHeight onResize={this.onResizeResource}>
                    <IndexResourcePane {...this.props} user={this.props.user} />
                </ReactResizeDetector>
            </SplitContainer.Side>
        </SplitContainer>
        return (
            this.props.deletePlaybookLoading ? <LoadingComponent active={this.props.deletePlaybookLoading} message="Deleting Playbook" /> :
                <SplitContainer
                    orientation="vertical"
                    minSize="10%"
                    maxSize={['50%', null]}
                    fillSides={[true, true]}
                    collapsible={[true, false]}
                    defaultSplitAt="25%"
                    resizeProxy={true}
                    collapsedIndex={this.state.collapsedBrowserPaneIndex}
                    splitAt={this.state.browserPaneSplit}
                    onResize={(browserPaneSplit) => {
                        if (Number(browserPaneSplit.replace("%", "")) < 11) {
                            this.setState({ collapsedBrowserPaneIndex: 0 })
                        } else {
                            this.setState({ browserPaneSplit })
                        }
                    }}
                    onExpand={() => {
                        this.setState({
                            collapsedBrowserPaneIndex: null,
                            browserPaneSplit: "25%"
                        })
                    }}
                    onCollapse={(index) => {
                        this.setState({
                            collapsedBrowserPaneIndex: index,
                            browserPaneSplit: "25%"
                        })
                    }}
                >
                    <SplitContainer
                        orientation="horizontal"
                        minSize="10%"
                        collapsible={[false, true]}
                        defaultSplitAt="75%"
                    >
                        <SplitContainer.Side className="Split-BrowserPane" >
                            <MyPracticeTreeView
                                history={this.props.history}
                                {...this.props} />
                        </SplitContainer.Side>
                        <SplitContainer.Side className="Split-HelpPane">
                            <HelpComponent />
                        </SplitContainer.Side>
                    </SplitContainer>
                    {designerContainer}
                </SplitContainer>

        );
    }
}

function mapStateToProps(state) {
    return {
        allList: state.lifeCycle.allList,
        treeNode: state.lifeCycle.treeNode,
        user: state.app.user,
        selectedOrganisation: state.app.selectedOrganisation,
        selectedWorkspaceState: state.app.selectedWorkspaceState,
        showResourecePaneFlag: state.lifeCycle.showResourecePaneFlag,
        selectedPracticeLibrary: state.lifeCycle.selectedPracticeLibrary,
        baseCategoriesArr: state.lifeCycle.baseCategoriesArr,
        categoriesArr: state.lifeCycle.categoriesArr,
        subCategoriesArr: state.lifeCycle.subCategoriesArr,
        scope: state.lifeCycle.scope,
        categoryTree: state.lifeCycle.categoryTree,
        categoryPublicTree: state.lifeCycle.categoryPublicTree,
        imageObjectCloudinary: state.lifeCycle.imageObjectCloudinary,
        PracticeLibrarys: state.lifeCycle.packArray,
        showLandingPageFlag: state.lifeCycle.showLandingPageFlag,
        setUpdatedImageName: state.lifeCycle.setUpdatedImageName,
        setDafaultImage: state.lifeCycle.setDafaultImage,
        isModalOpen: state.lifeCycle.isModalOpen,
        searchUserArr: state.lifeCycle.searchUserArr,
        userSearchObject: state.lifeCycle.userSearchObject,
        loaderStatus: state.users.loaderBar,
        arrangementPaneFlag: state.lifeCycle.arrangementPaneFlag,
        arrangementPaneActiveButtonFlag: state.lifeCycle.arrangementPaneActiveButtonFlag,
        libraryCardIndex: state.lifeCycle.libraryCardIndex,
        participantsData: state.lifeCycle.participantsData,
        packCount: state.lifeCycle.packCount,
        breadcrumbs: state.lifeCycle.breadcrumbs,
        isEditModalOpen: state.lifeCycle.isEditModalOpen,
        isRoleChangeModalOpen: state.lifeCycle.isRoleChangeModalOpen,
        selectedPracticeFlowActivity: state.createPack.selectedPracticeFlowActivity,
        parentPhase: state.createPack.parentPhase,
        parentCommunity: state.createPack.parentCommunity,
        selectedPracticeFlowCommunity: state.createPack.selectedPracticeFlowCommunity,
        activityAction: state.createPack.activityAction,
        communityActions: state.createPack.communityActions,
        publishedContent: state.createPack.publishedContent,
        isContentModalOpen: state.createPack.isContentModalOpen,
        isAddActivityModalOpen: state.createPack.isAddActivityModalOpen,
        isPhaseAddFlag: state.createPack.isPhaseAddFlag,
        displaySecondMenu: state.lifeCycle.displaySecondMenu,
        activityList: state.lifeCycle.activityList,
        isCreatePracticeCardDisplay: state.lifeCycle.isCreatePracticeCard,
        practiceLabelName: state.lifeCycle.practiceLabelName,
        activityUniqueId: state.createPack.activityUniqueId,
        validationCheck: state.createPack.validationCheck,
        isDragable: state.lifeCycle.isDragable,
        activityBeforeEdit: state.createPack.activityBeforeEdit,
        invitedUsersArray: state.lifeCycle.invitedUsersArray,
        playbookToExport: state.lifeCycle.playbookToExport,
        playbookInvitaions: state.lifeCycle.playbookInvitaions,
        searchInviteUserArr: state.lifeCycle.searchInviteUserArr,
        isPlaybookInvitationModalOpen: state.lifeCycle.isPlaybookInvitationModalOpen,
        enableLinkActivity: state.lifeCycle.enableLinkActivity,
        playbookSearchQuery:state.lifeCycle.playbookSearchQuery,
        // resourcepaneDefaultOpenTab: state.createPack.resourcepaneDefaultOpenTab,
        componentDesignerDimension: state.initiatives.componentDesignerDimension,
        selectedParamOrganization: state.initiatives.selectedParamOrganization,
        loadingPacks: state.loading.effects.lifeCycle.getPacksByStatusArray && state.loading.models.lifeCycle,
        loadingPack: state.loading.effects.lifeCycle.getPackAndUpdateSelectedPracticeLibary && state.loading.models.lifeCycle,
        loadingActivity: state.loading.effects.createPack.getSelectedActivityAsync && state.loading.models.createPack,
        setUniqueId: state.lifeCycle.setUniqueId,
        redirectFromDashboard: state.home.redirectFromDashboard,
        splitAtSize: state.lifeCycle.splitAtSize,
        graph: state.lifeCycle.graph,
        deletePlaybookLoading: state.loading.effects.lifeCycle.deletePlaybook && state.loading.models.lifeCycle,
        loading: state.loading.effects.lifeCycle.addNewPracticeAsync,
        publishingPracticeLoader: state.loading.effects.lifeCycle.publishPractice,
        validPracticeName: state.lifeCycle.validPracticeName,
        collapsedResourcePaneIndexTemp: state.app.collapsedResourcePaneIndexTemp,
        selectedAccount: state.app.selectedAccount,
        envData: state.app.envData,
        accountSubscriptionDetail: state.app.accountSubscriptionDetail,
        playbookError: state.lifeCycle.playbookError,
        currentNote: state.lifeCycle.currentNote,
        routeParams: state.app.routeParams,
        sortingFlag: state.lifeCycle.sortingFlag,
        currentPathValue: state.lifeCycle.currentPathValue,
        copyingPlaybook: state.loading.effects.lifeCycle.copyPlaybook && state.loading.models.lifeCycle,
        publicCategoryList: state.app.publicCategoryList,
        selectedContent: state.content.selectedContent,
        loadingActivitySummary: state.loading.effects.lifeCycle.getActivitySummary && state.loading.models.lifeCycle,
        activitySummary: state.lifeCycle.activitySummary,
        playbookImagesBuffer:state.lifeCycle.playbookImagesBuffer,
        playbookImagesLoading:state.loading.effects.lifeCycle.getPlaybookImages,
        singleActivityDetail: state.lifeCycle.singleActivityDetail,
        playbookPath: state.app.playbookPath,
        publishActivityCountByCategory: state.lifeCycle.publishActivityCountByCategory,
        currentOrganization: state.organizationTab.currentOrganization,
        teamList: state.lifeCycle.teamList,
        orgTeams: state.organizationUnit.orgTeams,
        integrationEntities: state.integrations.integrationEntities,
        entityIntegrationsConfig: state.integrations.entityIntegrationsConfig,
        filterByStatus: state.lifeCycle.filterByStatus,
        selectedTreeId: state.lifeCycle.selectedTreeId,
        selectedDataItem: state.createPack.selectedDataItem,
        percentageGenerationComplete:state.lifeCycle.percentageGenerationComplete,
        percentageActivitesGenerated:state.lifeCycle.percentageActivitesGenerated,
        generatingActivityDetails: state.loading.effects.lifeCycle.allActivitiesWebSearch,
        customEmailTemplates:state.lifeCycle.customEmailTemplates,
        scenarios:state.lifeCycle.scenarios,
        scenarioInputs:state.lifeCycle.scenarioInputs,
        activityActions:state.createPack.activityActions,
        entities:state.lifeCycle.entities,
        entityFieldMapping:state.lifeCycle.entityFieldMapping,
    };
}

const connectedLifecycleDesignerPage = withRouter(connect(mapStateToProps)(LifecycleDesigner));

export { connectedLifecycleDesignerPage as LifecycleDesigner };
